export default {
  headers: [
    'No Protection',
    'Lenscap',
    'Lenscap+'
  ],
  rows: {
    'Max Liability': {
      'No Protection': '100',
      Lenscap: '10',
      'Lenscap+': '10'
    },
    Drops: {
      'No Protection': false,
      Lenscap: true,
      'Lenscap+': true
    },
    'Bear Attacks': {
      'No Protection': false,
      Lenscap: true,
      'Lenscap+': true
    },
    Theft: {
      'No Protection': false,
      Lenscap: false,
      'Lenscap+': true
    },
    Fire: {
      'No Protection': false,
      Lenscap: false,
      'Lenscap+': true
    },
    Lightning: {
      'No Protection': false,
      Lenscap: false,
      'Lenscap+': true
    },
    Windstorm: {
      'No Protection': false,
      Lenscap: false,
      'Lenscap+': true
    },
    Earthquake: {
      'No Protection': false,
      Lenscap: false,
      'Lenscap+': true
    },
    Flood: {
      'No Protection': false,
      Lenscap: false,
      'Lenscap+': true
    },
    'Fell from Aircraft': {
      'No Protection': false,
      Lenscap: false,
      'Lenscap+': true
    }
  }
}
